.skeleton {
  display: block;
  border-radius: var(--radius-md);
  background: linear-gradient(
    90deg,
    var(--color-surface-hover) 25%,
    var(--color-border) 37%,
    var(--color-surface-hover) 63%
  );
  background-size: 400% 100%;
  animation: orthos-shimmer 1.4s ease infinite;
}
